<template>
    <div>
        <div v-if="form && !componentIsLoading" class="content-wrapper">
            <h4>
                Mise à jour du bénéficiaire {{ form.model.first_names }} {{ form.model.last_name }}
            </h4>

            <hr>

            <resource-form
                v-if="form"
                ref="editionForm"
                :model="form.model"
                :schema="form.schema"
                :triggers="form.triggers"
                :no-form-group="true"
                @submit="updateOwner">
                <template slot="cancel">
                    <button class="btn btn-default btn-sm" @click.prevent="$emit('form-closed')">Annuler</button>
                </template>
            </resource-form>
        </div>

        <component-loader v-else></component-loader>
    </div>
</template>

<script type="text/babel">
    import {mapState, mapActions} from "vuex"
    import ResourceForm from 'components/Forms/ResourceForm'
    import ComponentLoader from 'components/ComponentLoader'
    
    export default {
        name: 'BeneficialOwnerEditionForm',

        props: {
            declarationId: {
                type: Number,
                default: null,
                required: true
            },
            ownerId: {
                type: Number,
                default: null,
                required: true
            }
        },

        components: {
            ResourceForm,
            ComponentLoader
        },

        data() {
            return {
                componentIsLoading: false
            }
        },

        created() {
            this.fetchEditionForm()
        },

        methods: {
            ...mapActions('beneficialOwners', [
                'fetchBeneficialOwnerEditionForm',
                'updateBeneficialOwner'
            ]),

            fetchEditionForm() {
                const params = {
                    declarationId: this.declarationId,
                    ownerId: this.ownerId
                }

                this.componentIsLoading = true

                this.fetchBeneficialOwnerEditionForm(params)
                    .then(() => this.componentIsLoading = false)
            },

            updateOwner(event) {
                this.editionForm.isLoading = true
                this.updateBeneficialOwner(event.data)
                    .then(() => this.$emit('success'))
                    .catch(() => {})
                    .then(() => this.editionForm.isLoading = false)
            }
        },

        computed: {
            ...mapState('beneficialOwners', {
                'form': 'ownerEditionForm'
            }),

            editionForm() {
                return this.$refs.editionForm
            }
        }
    }
</script>

<style lang="scss" scoped>
    .content-wrapper {
        padding: 15px;
        background-color: #fafafa;
    }
</style>



// WEBPACK FOOTER //
// client/components/BeneficialOwners/BeneficialOwnerEditionForm.vue